import classNames from 'classnames'

type Props = {
  showProblemNumber: boolean
  problemNumber: number
}

const ProblemNumber = ({ problemNumber, showProblemNumber }: Props) => (
  <div
    className={classNames(
      'bg-black bg-opacity-50 duration-500 text-center text-8xl w-full absolute top-0 bottom-0 my-auto h-32 flex justify-center',
      {
        'opacity-100': showProblemNumber,
        'opacity-0': !showProblemNumber,
      }
    )}
  >
    {problemNumber}
  </div>
)

export default ProblemNumber
